document.addEventListener('DOMContentLoaded', () => {
  const money = (cents) => {
    try {
      return (window.Shopify?.formatMoney
        ? Shopify.formatMoney(cents, window.themeMoneyFormat)
        : 'Rs. ' + (Number(cents) / 100).toLocaleString('en-PK'));
    } catch (e) {
      return 'Rs. ' + (Number(cents) / 100).toFixed(0);
    }
  };

  /* Mobile menu */
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  const closeEls = document.querySelectorAll('[data-menu-close]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => nav.classList.add('is-open'));
    closeEls.forEach((el) => el.addEventListener('click', () => nav.classList.remove('is-open')));
  }

  document.querySelectorAll('.nav-has-dropdown').forEach((item) => {
    item.addEventListener('mouseenter', () => item.classList.add('open'));
    item.addEventListener('mouseleave', () => item.classList.remove('open'));
  });

  /* Reveal */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const reveals = document.querySelectorAll('.reveal');
    if (reveals.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach((el) => io.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add('is-in'));
    }
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* Sticky ATC */
  const mainBtn = document.querySelector('[data-product-atc]');
  const buySubmit = document.getElementById('qd-buy-submit');
  const sticky = document.querySelector('[data-sticky-atc]');
  const stickyObserveTarget = buySubmit || mainBtn;
  if (stickyObserveTarget && sticky && 'IntersectionObserver' in window) {
    const io2 = new IntersectionObserver((entries) => {
      entries.forEach((e) => sticky.classList.toggle('is-visible', !e.isIntersecting));
    }, { threshold: 0 });
    io2.observe(stickyObserveTarget);
  }

  /* Gallery thumbs */
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('[data-main-image]');
      if (!main) return;
      main.src = thumb.dataset.full || thumb.querySelector('img')?.src || '';
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* Qty */
  const qty = document.querySelector('[data-qty]');
  if (qty) {
    const input = qty.querySelector('input#buy-qty, input[name="quantity"]');
    qty.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (!input) return;
      input.value = Math.max(1, Number(input.value) - 1);
    });
    qty.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (!input) return;
      input.value = Math.min(99, Number(input.value) + 1);
    });
  }

  /* Option → variant mapping */
  const productJsonEl = document.querySelector('[data-product-json]');
  let productData = null;
  try {
    productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
  } catch (e) {
    productData = null;
  }

  const formatMoneyShopify = (cents) => {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return 'Rs. ' + Math.round(Number(cents) / 100).toLocaleString('en-PK');
  };

  function selectedOptions() {
    const opts = [];
    document.querySelectorAll('.size-options[data-option-index]').forEach((group) => {
      const selected = group.querySelector('.size-option.selected');
      opts[Number(group.dataset.optionIndex)] = selected?.dataset.value || '';
    });
    document.querySelectorAll('select[data-option-select][data-option-index]').forEach((sel) => {
      opts[Number(sel.dataset.optionIndex)] = sel.value || '';
    });
    document.querySelectorAll('[data-offer-radios]').forEach((group) => {
      const checked = group.querySelector('.pdp-offer-radio:checked');
      if (!checked) return;
      const idx = Number(group.dataset.optionIndex);
      opts[idx] = checked.value || checked.dataset.value || '';
    });
    return opts;
  }

  function findVariant(options) {
    if (!productData?.variants) return null;
    return productData.variants.find((v) =>
      options.every((opt, i) => !opt || v[`option${i + 1}`] === opt)
    );
  }

  function setMainImage(src, mediaId) {
    if (!src && mediaId == null) return;
    const main = document.querySelector('[data-main-image]');
    if (main && src) {
      main.src = src;
      if (mediaId != null) main.setAttribute('data-media-id', String(mediaId));
    }
    document.querySelectorAll('[data-thumb]').forEach((t) => {
      const byId = mediaId != null && String(t.dataset.mediaId) === String(mediaId);
      const full = t.dataset.full || '';
      const bySrc = !!(src && full && (src === full || src.split('?')[0] === full.split('?')[0]));
      t.classList.toggle('is-active', byId || bySrc);
    });
  }

  function resolveVariantImage(variant, imageHint, mediaIdHint, mediaIndexHint) {
    if (imageHint) return { src: imageHint, id: mediaIdHint || null };
    if (variant?.featured_image?.src) {
      return { src: variant.featured_image.src, id: variant.featured_image.id || mediaIdHint || null };
    }
    const idx =
      mediaIndexHint != null
        ? Number(mediaIndexHint)
        : variant && variant.media_index != null
          ? Number(variant.media_index)
          : null;
    if (idx != null && productData?.media?.[idx]?.src) {
      return { src: productData.media[idx].src, id: productData.media[idx].id };
    }
    return { src: null, id: null };
  }

  function updateVariantUI(variant, imageHint, mediaIdHint, mediaIndexHint) {
    if (!variant) return;
    const input = document.querySelector('[data-variant-input]');
    if (input) input.value = variant.id;
    const price = document.querySelector('[data-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const compare = document.querySelector('[data-compare]');
    const save = document.querySelector('[data-save]');
    const priceText = formatMoneyShopify(variant.price);
    if (price) price.textContent = priceText;
    if (stickyPrice) stickyPrice.textContent = priceText;
    if (compare) {
      if (variant.compare_at_price > variant.price) {
        compare.style.display = '';
        compare.textContent = formatMoneyShopify(variant.compare_at_price);
      } else {
        compare.style.display = 'none';
      }
    }
    if (save) {
      if (variant.compare_at_price > variant.price) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        save.style.display = '';
        save.textContent = `Save ${pct}%`;
      } else {
        save.style.display = 'none';
      }
    }
    document.querySelectorAll('[data-product-atc], #qd-buy-submit, [data-qd-buy-now], [data-dawam-buynow]').forEach((btn) => {
      btn.disabled = !variant.available;
    });
    const wa = document.querySelector('[data-wa-btn]');
    if (wa && productData) {
      const phone = (wa.href.match(/wa\.me\/(\d+)/) || [])[1] || (window.REDY_THEME && window.REDY_THEME.whatsapp) || '923024593845';
      const pre = (window.REDY_THEME && window.REDY_THEME.whatsappPrefill) || 'Hi Redy, I want to order:';
      const title = encodeURIComponent(`${pre} ${productData.title} (${variant.title})`);
      wa.href = `https://wa.me/${phone}?text=${title}`;
    }
    const resolved = resolveVariantImage(variant, imageHint, mediaIdHint, mediaIndexHint);
    if (resolved.src) setMainImage(resolved.src, resolved.id);
  }

  document.querySelectorAll('.size-options').forEach((group) => {
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('.size-option');
      if (!btn) return;
      group.querySelectorAll('.size-option').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      const label = document.querySelector(`[data-option-label="${group.dataset.optionIndex}"]`);
      if (label) label.textContent = btn.dataset.value;
      updateVariantUI(findVariant(selectedOptions()));
    });
  });

  document.querySelectorAll('select[data-option-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      updateVariantUI(findVariant(selectedOptions()));
    });
  });

  /* Meezan-style offer radios → price + bundle image */
  document.querySelectorAll('[data-offer-radios]').forEach((group) => {
    group.addEventListener('change', (e) => {
      const radio = e.target.closest('.pdp-offer-radio');
      if (!radio) return;
      group.querySelectorAll('.pdp-offer-option').forEach((lab) => lab.classList.remove('is-selected'));
      const lab = group.querySelector(`label[for="${radio.id}"]`);
      if (lab) lab.classList.add('is-selected');
      const label = document.querySelector(`[data-option-label="${group.dataset.optionIndex}"]`);
      if (label) label.textContent = radio.value || radio.dataset.value || '';
      const variant =
        (radio.dataset.variantId && productData?.variants?.find((v) => String(v.id) === String(radio.dataset.variantId))) ||
        findVariant(selectedOptions());
      updateVariantUI(
        variant,
        radio.dataset.variantImage || null,
        radio.dataset.mediaId || null,
        radio.dataset.mediaIndex != null ? radio.dataset.mediaIndex : null
      );
    });
  });

  /* Tabs */
  const tabs = document.querySelector('[data-tabs]');
  if (tabs) {
    tabs.querySelectorAll('[data-tab]').forEach((btn) => {
      btn.addEventListener('click', () => {
        tabs.querySelectorAll('[data-tab]').forEach((b) => b.classList.remove('active'));
        tabs.querySelectorAll('[data-panel]').forEach((p) => p.classList.remove('active'));
        btn.classList.add('active');
        tabs.querySelector(`[data-panel="${btn.dataset.tab}"]`)?.classList.add('active');
      });
    });
  }

  document.querySelector('[data-scroll-ask]')?.addEventListener('click', (e) => {
    e.preventDefault();
    const askBtn = document.querySelector('[data-tab="ask"]');
    askBtn?.click();
    document.getElementById('ask')?.scrollIntoView({ behavior: 'smooth' });
  });

  /* Codify Buy Now — REAL form submit only (no fetch /cart/add.js) */
  const BUYNOW_FLAG = 'dawam_buynow';
  const buyForm = document.getElementById('qd-buy-form');

  function markBuyNow() {
    try {
      sessionStorage.setItem(BUYNOW_FLAG, '1');
    } catch (e) {}
  }

  document.getElementById('qd-buy-submit')?.addEventListener('click', () => {
    markBuyNow();
  });

  document.querySelectorAll('[data-qd-buy-now]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const submitBtn = document.getElementById('qd-buy-submit');
      if (!submitBtn || submitBtn.disabled) return;
      markBuyNow();
      submitBtn.click();
    });
  });

  /* Optional: clear cart on PDP load — skip mid Codify OTP */
  const productRoot = document.querySelector('.product[data-clear-cart-on-pdp]');
  if (productRoot && productRoot.getAttribute('data-clear-cart-on-pdp') === '1') {
    let skipClear = false;
    try {
      skipClear = sessionStorage.getItem(BUYNOW_FLAG) === '1';
    } catch (e) {}
    if (!skipClear) {
      fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});
    }
  }

  /* Ask form → WhatsApp */
  document.querySelector('[data-ask-form]')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const text = encodeURIComponent(
      `Question about ${productData?.title || 'product'}\nName: ${fd.get('name')}\nEmail: ${fd.get('email')}\n${fd.get('message')}`
    );
    const wa = document.querySelector('[data-wa-btn]');
    const phone = (wa?.href.match(/wa\.me\/(\d+)/) || [])[1] || '923024593845';
    window.open(`https://wa.me/${phone}?text=${text}`, '_blank');
  });

  /* Size calculator */
  const sizeModal = document.getElementById('size-calc-modal');
  const openCalc = () => sizeModal?.removeAttribute('hidden');
  const closeCalc = () => sizeModal?.setAttribute('hidden', '');
  document.querySelector('[data-open-size-calc]')?.addEventListener('click', openCalc);
  sizeModal?.querySelectorAll('[data-close-size-calc]').forEach((el) => el.addEventListener('click', closeCalc));
  document.querySelector('[data-run-size-calc]')?.addEventListener('click', () => {
    const bust = Number(document.getElementById('calc-bust')?.value || 0);
    const fit = document.getElementById('calc-fit')?.value || 'regular';
    const result = document.querySelector('[data-size-calc-result]');
    if (!result) return;
    if (bust < 28 || bust > 60) {
      result.textContent = 'Please enter a bust measurement between 28 and 60 inches.';
      return;
    }
    let band = Math.round(bust);
    if (band % 2 === 1) band += 1;
    let cup = 'B';
    if (fit === 'relaxed') cup = 'C';
    if (bust >= 40) cup = fit === 'relaxed' ? 'D' : 'C';
    result.textContent = `Suggested size: ${band}${cup} (or nearby size in chart). Always check the product size guide.`;
  });

  /* Delivery timeline */
  const trackEl = document.querySelector('[data-delivery-track]');
  if (trackEl) {
    const addBusinessDays = (fromDate, days) => {
      const d = new Date(fromDate);
      let left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) left--;
      }
      return d;
    };
    const fmt = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const range = (a, b) => (a.toDateString() === b.toDateString() ? fmt(a) : `${fmt(a)} - ${fmt(b)}`);
    const base = new Date();
    base.setHours(12, 0, 0, 0);
    const readyS = addBusinessDays(base, 0);
    const readyE = addBusinessDays(base, 1);
    const delS = addBusinessDays(base, 3);
    const delE = addBusinessDays(base, 5);
    trackEl.innerHTML = `
      <div class="delivery-timeline" role="list" aria-label="Delivery estimate">
        <div class="delivery-timeline__step" role="listitem">
          <div class="delivery-timeline__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 016 0"/></svg></div>
          <div class="delivery-timeline__text"><strong>Ordered</strong><span>${fmt(base)}</span></div>
        </div>
        <div class="delivery-timeline__step" role="listitem">
          <div class="delivery-timeline__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M1 7h11v10H1z"/><path d="M12 10h4l3 3v4h-7V10z"/><circle cx="5.5" cy="18.5" r="1.5"/><circle cx="16.5" cy="18.5" r="1.5"/></svg></div>
          <div class="delivery-timeline__text"><strong>Order Ready</strong><span>${range(readyS, readyE)}</span></div>
        </div>
        <div class="delivery-timeline__step" role="listitem">
          <div class="delivery-timeline__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M12 21s7-5.2 7-11a7 7 0 10-14 0c0 5.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg></div>
          <div class="delivery-timeline__text"><strong>Delivered</strong><span>${range(delS, delE)}</span></div>
        </div>
      </div>`;
  }

  /* Cart drawer */
  const drawer = document.querySelector('[data-cart-drawer]');
  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCart();
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  };
  document.querySelectorAll('[data-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
    const itemsEl = document.querySelector('[data-cart-items]');
    const totalEl = document.querySelector('[data-cart-total]');
    const shipEl = document.querySelector('[data-cart-ship]');
    if (totalEl) totalEl.textContent = formatMoneyShopify(cart.total_price);
    const freeMinPkr = Number(window.REDY_THEME && window.REDY_THEME.freeShippingMin);
    const freeMin = (Number.isFinite(freeMinPkr) ? freeMinPkr : 0) * 100;
    if (shipEl) {
      if (freeMin <= 0 || cart.total_price >= freeMin) {
        shipEl.innerHTML = '<strong>Free shipping</strong> on all orders';
      } else {
        shipEl.innerHTML = `You are <strong>${formatMoneyShopify(freeMin - cart.total_price)}</strong> away from free shipping`;
      }
    }
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-empty-msg">Your bag is empty.</p><a class="btn btn-primary btn-block" href="/collections/all">Shop Now</a>';
      return;
    }
    itemsEl.innerHTML = cart.items
      .map(
        (item) => `
      <div class="cart-drawer-item">
        <img src="${item.image || ''}" alt="" width="64" height="80">
        <div>
          <strong>${item.product_title}</strong>
          <div class="cart-drawer-meta">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Qty ${item.quantity}</div>
          <div>${formatMoneyShopify(item.final_line_price)}</div>
        </div>
      </div>`
      )
      .join('');
  }

  /* AJAX add to cart — ONLY for [data-product-atc] button (not Buy Now submit) */
  if (buyForm && mainBtn) {
    mainBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const fd = new FormData(buyForm);
      mainBtn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
        });
        openCart();
        refreshCart();
      } catch (err) {
        /* fallback: do not use Buy Now path */
        alert('Could not add to cart. Please try again.');
      } finally {
        mainBtn.disabled = false;
      }
    });
  }

  /* IMPORTANT: never preventDefault on #qd-buy-form native submit — Codify needs it */

  /* Search overlay */
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  document.querySelector('[data-search-open]')?.addEventListener('click', () => {
    searchOverlay?.removeAttribute('hidden');
    searchOverlay?.classList.add('is-open');
    searchInput?.focus();
  });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => {
    searchOverlay?.setAttribute('hidden', '');
    searchOverlay?.classList.remove('is-open');
  });
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(async () => {
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
        const data = await res.json();
        const products = data.resources?.results?.products || [];
        if (!searchResults) return;
        if (!products.length) {
          searchResults.innerHTML = '<p>No products found. <a href="/search?q=' + encodeURIComponent(q) + '">View all results</a></p>';
          return;
        }
        searchResults.innerHTML = products
          .map(
            (p) => `
          <a class="search-result-row" href="${p.url}">
            <img src="${p.image || ''}" alt="" width="48" height="60">
            <span>${p.title}</span>
            <strong>${p.price}</strong>
          </a>`
          )
          .join('');
      } catch (err) {
        if (searchResults) {
          searchResults.innerHTML = `<a href="/search?q=${encodeURIComponent(q)}">Search for “${q}”</a>`;
        }
      }
    }, 250);
  });

  /* Announcement ticker */
  const tickers = document.querySelectorAll('.announcement-bar .ticker-item');
  if (tickers.length > 1) {
    let i = 0;
    setInterval(() => {
      tickers[i].classList.remove('active');
      i = (i + 1) % tickers.length;
      tickers[i].classList.add('active');
    }, 4000);
  }

  /* Hero slider */
  const heroSlider = document.querySelector('[data-hero-slider]');
  if (heroSlider) {
    const slides = [...heroSlider.querySelectorAll('[data-hero-slide]')];
    const dots = [...document.querySelectorAll('[data-hero-dot]')];
    let idx = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active') || s.classList.contains('active')));
    const setActive = (n) => {
      if (!slides.length) return;
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === n);
        s.classList.toggle('active', i === n);
      });
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === n);
        d.classList.toggle('active', i === n);
      });
      idx = n;
    };
    setActive(idx < 0 ? 0 : idx);
    dots.forEach((dot) =>
      dot.addEventListener('click', () => setActive(Number(dot.dataset.heroDot)))
    );
    if (slides.length > 1) setInterval(() => setActive((idx + 1) % slides.length), 5500);
  }

  /* Wishlist (localStorage) */
  const WL_KEY = 'redy_wishlist_v1';
  const readWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(WL_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };
  const writeWishlist = (list) => localStorage.setItem(WL_KEY, JSON.stringify(list));
  const updateWishlistCount = () => {
    const list = readWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(list.length);
      if (list.length) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-wishlist]').forEach((btn) => {
      btn.classList.toggle('active', list.some((x) => x.handle === btn.dataset.wishlist));
    });
  };
  const moneyFromCents = (cents) => {
    if (window.Shopify?.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return 'Rs. ' + Math.round(Number(cents) / 100).toLocaleString('en-PK');
  };
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('[data-product-card]');
    const handle = btn.dataset.wishlist;
    let list = readWishlist();
    const i = list.findIndex((x) => x.handle === handle);
    if (i > -1) list.splice(i, 1);
    else {
      list.push({
        handle,
        title: card?.dataset.productTitle || handle,
        url: card?.dataset.productUrl || `/products/${handle}`,
        image: card?.dataset.productImage || '',
        price: Number(card?.dataset.productPrice || 0),
      });
    }
    writeWishlist(list);
    updateWishlistCount();
  });
  updateWishlistCount();

  const wlGrid = document.querySelector('[data-wishlist-grid]');
  if (wlGrid) {
    const list = readWishlist();
    if (!list.length) {
      wlGrid.innerHTML =
        '<div style="grid-column:1/-1;text-align:center;padding:64px;"><p style="color:#9a8a8a;margin-bottom:16px;">Your wishlist is empty</p><a href="/collections/all" class="btn btn-primary">Browse Collection</a></div>';
    } else {
      wlGrid.innerHTML = list
        .map(
          (item) => `
        <a class="product-card" href="${item.url}">
          <div class="product-card__media">
            ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}
            <button type="button" class="wishlist-card-btn active" data-wishlist="${item.handle}" aria-label="Remove"><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.75"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg></button>
          </div>
          <div class="product-card__info">
            <h3 class="product-card__title">${item.title}</h3>
            <div class="product-card__price"><span class="product-card__price-now">${moneyFromCents(item.price)}</span></div>
          </div>
        </a>`
        )
        .join('');
    }
  }
});
